import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'gc-why-face-id-dialog',
  templateUrl: './why-face-id-dialog.component.html',
  styleUrls: ['./why-face-id-dialog.component.scss'],
  standalone: false,
})
export class WhyFaceIdDialogComponent {
  constructor(public dialogRef: MatDialogRef<WhyFaceIdDialogComponent>) {}
}
